import { useEffect } from 'react'
import { appSelectors } from 'redux/reducers/app'
import { useAppSelector } from 'shared/hooks'
import { initSentry, integrateGTM, integrateHotJar } from 'shared/integrations'

export function useTrackingUser() {
	const userId = useAppSelector(
		state => appSelectors.appProfile(state)?.id ?? ''
	)

	useEffect(() => {
		if (userId) {
			Promise.all([initSentry(userId), integrateGTM(), integrateHotJar(userId)])
		}
	}, [userId])
}
